import { render, staticRenderFns } from "./ManagementAttractiveness.vue?vue&type=template&id=1b3b6174&scoped=true&"
import script from "./ManagementAttractiveness.vue?vue&type=script&lang=ts&"
export * from "./ManagementAttractiveness.vue?vue&type=script&lang=ts&"
import style0 from "./ManagementAttractiveness.vue?vue&type=style&index=0&id=1b3b6174&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3b6174",
  null
  
)

export default component.exports